import React, { FunctionComponent } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
// import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
// import { fetch_all, fetch_all_with_count, fetch_one } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
// import { currentPracticeAtom } from '../../../../lib/practice';

// import {
//   Divider,
//   Grid,
//   Paper,
// } from '@mui/material';

// import {
//   Button,
//   Typography
// } from '../../../../components/v2/styled';

import { User } from '../../../../models/User';
import { CoachUserWidgetsPictureAndTags } from './PictureAndTags';
import { CoachUserWidgetsConsentInformation } from './ConsentInformation';
import { CoachUserWidgetsNotificationInformation } from './NotificationInformation';
import { CoachUserWidgetsCoursesSmall } from './CoursesSmall';
import { CoachUserWidgetsMollieLinksSmall } from './MollieLinksSmall';
import { CoachUserWidgetsWeightTrigger } from './WeightTrigger';
import { CoachUserWidgetsDetailsBasic } from './DetailsBasic';
import { CoachUserWidgetsDetailsContact } from './DetailsContact';
import { CoachUserWidgetsDetailsExtra } from './DetailsExtra';
import { CoachUserWidgetsAppointmentsSmall } from './AppointmentsSmall';
import { CoachUserWidgetsFileSmall } from './FileSmall';
import { CoachUserWidgetsDiarySmall } from './DiarySmall';
import { CoachUserWidgetsMeasuresSmall } from './MeasuresSmall';
import { CoachUserWidgetsQuestionnairesSmall } from './QuestionnairesSmall';
import { CoachUserWidgetsGotoLinks } from './GotoLinks';
import { CoachUserWidgetsActions } from './Actions';
import { CoachUserWidgetsAccountManagement } from './AccountManagement';
import { CoachUserWidgetsCommunicationSmall } from './CommunicationSmall';
import { CoachUserWidgetsBasicIntake } from './BasicIntake';
import { CoachUserWidgetsBasicTreatment } from './BasicTreatment';
import { CoachUserWidgetsBasicMeasureUploads } from './BasicMeasureUploads';
import { CoachUserWidgetsBasicSleep } from './BasicSleep';
import { CoachUserWidgetsBasicAdviceUploads } from './BasicAdviceUploads';
import { CoachUserWidgetsBasicAdvice } from './BasicAdvice';
import { CoachUserWidgetsTimeline } from './Timeline';
import { CoachUserWidgetsStatus } from './Status';
import { CoachUserWidgetsInternalComment } from './InternalComment';
import { CoachUserWidgetsWorkshops } from './Workshops';
import { CoachUserWidgetsCalculation } from './Calculation';

// const { DateTime } = require("luxon");

type Props = {
  cl: string;
  object: User;
  mutationCustomAction: any;
  passResetLink?: string;
  passResetEmail?: string;
  setPremiumEhealthOpen: (b:boolean) => void;
  setPremiumZorgmailOpen: (b:boolean) => void;
  setPremiumNutriMailOpen: (b:boolean) => void;
  setPremiumPaymentsOpen: (b:boolean) => void;
  setPremiumNutriAppointmentOpen: (b:boolean) => void;
  setPremiumNutriAdviceOpen: (b:boolean) => void;
  setPremiumMeasuresWeightOpen: (b:boolean) => void;
  setPremiumQuestionnaireOpen: (b:boolean) => void;
  setPremiumKnowledgeOpen: (b:boolean) => void;
  setPremiumDiaryEatOpen: (b:boolean) => void;
  setPremiumDiaryMoveOpen: (b:boolean) => void;
  groupsEatEditing: boolean;
  setGroupsEatEditing: (b:boolean) => void;
  groupsMoveEditing: boolean;
  setGroupsMoveEditing: (b:boolean) => void;
  newEatGroup?: string;
  setNewEatGroup: (s:string) => void;
  newMoveGroup?: string;
  setNewMoveGroup: (s:string) => void;
  objectRefetch: any;
  setEhealthInitOpen: (b:boolean) => void;
  setZorgmailInitOpen: (b:boolean) => void;
  setNewEpisodeWarningOpen: (b:boolean) => void;
  consentAsked?: string;
}

export const CoachUserWidgetsBaseMapper: FunctionComponent<Props> = ({
  cl,
  object, objectRefetch,
  mutationCustomAction,
  passResetLink, passResetEmail,
  setPremiumEhealthOpen, setPremiumZorgmailOpen, setPremiumNutriMailOpen, setPremiumPaymentsOpen, setPremiumNutriAppointmentOpen,
  setPremiumNutriAdviceOpen, setPremiumMeasuresWeightOpen, setPremiumQuestionnaireOpen, setPremiumKnowledgeOpen,
  setEhealthInitOpen, setZorgmailInitOpen, setNewEpisodeWarningOpen,
  consentAsked, setPremiumDiaryEatOpen, setPremiumDiaryMoveOpen,
  groupsEatEditing, setGroupsEatEditing,
  groupsMoveEditing, setGroupsMoveEditing,
  newEatGroup, setNewEatGroup,
  newMoveGroup, setNewMoveGroup
}) => {
  const [login, setLogin] = useAtom(loginAtom);

  return <>
    {cl === "picture_and_tags" && <CoachUserWidgetsPictureAndTags
      object={object}
      setPremiumEhealthOpen={setPremiumEhealthOpen}
      setPremiumZorgmailOpen={setPremiumZorgmailOpen}
      setPremiumNutriMailOpen={setPremiumNutriMailOpen}
      setEhealthInitOpen={setEhealthInitOpen}
      setZorgmailInitOpen={setZorgmailInitOpen}
      objectRefetch={objectRefetch}
    />}

    {cl === "consent_information" && object?.type === "User::User" && <CoachUserWidgetsConsentInformation
      object={object}
    />}

    {cl === "notification_information" && object?.type === "User::User" && <CoachUserWidgetsNotificationInformation
      object={object}
    />}

    {cl === "courses_small" && !login?.is_secretary && <CoachUserWidgetsCoursesSmall
      object={object}
      setPremiumKnowledgeOpen={setPremiumKnowledgeOpen}
    />}

    {cl === "mollie_links_small" && !login?.is_secretary && <CoachUserWidgetsMollieLinksSmall
      object={object}
      setPremiumPaymentsOpen={setPremiumPaymentsOpen}
    />}

    {cl === "weight_trigger" && <CoachUserWidgetsWeightTrigger
      object={object}
      mutationCustomAction={mutationCustomAction}
    />}

    {cl === "details_basic" && <CoachUserWidgetsDetailsBasic
      object={object}
    />}
    {cl === "details_contact" && <CoachUserWidgetsDetailsContact
      object={object}
    />}
    {cl === "details_extra" && object?.type === "User::User" && <CoachUserWidgetsDetailsExtra
      object={object}
    />}

    {cl === "appointments_small" && object?.type === "User::User" && <CoachUserWidgetsAppointmentsSmall
      object={object}
      setPremiumNutriAppointmentOpen={setPremiumNutriAppointmentOpen}
    />}

    {cl === "files_small" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsFileSmall
      object={object}
      mutationCustomAction={mutationCustomAction}
      consentAsked={consentAsked}
      setPremiumNutriAdviceOpen={setPremiumNutriAdviceOpen}
      setNewEpisodeWarningOpen={setNewEpisodeWarningOpen}
    />}

    {cl === "diary_small" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsDiarySmall
      object={object}
      mutationCustomAction={mutationCustomAction}
      setPremiumDiaryEatOpen={setPremiumDiaryEatOpen}
      setPremiumDiaryMoveOpen={setPremiumDiaryMoveOpen}
      groupsEatEditing={groupsEatEditing}
      setGroupsEatEditing={setGroupsEatEditing}
      groupsMoveEditing={groupsMoveEditing}
      setGroupsMoveEditing={setGroupsMoveEditing}
      newEatGroup={newEatGroup}
      setNewEatGroup={setNewEatGroup}
      newMoveGroup={newMoveGroup}
      setNewMoveGroup={setNewMoveGroup}
    />}

    {cl === "measures_small" && object?.type === "User::User" && <CoachUserWidgetsMeasuresSmall
      object={object}
      setPremiumMeasuresWeightOpen={setPremiumMeasuresWeightOpen}
    />}

    {cl === "questionnaires_small" && !login?.is_secretary && <CoachUserWidgetsQuestionnairesSmall
      object={object}
      setPremiumQuestionnaireOpen={setPremiumQuestionnaireOpen}
    />}

    {cl === "communication_nutri" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsCommunicationSmall
      source="nutri"
      object={object}
      setPremiumNutriMailOpen={setPremiumNutriMailOpen}
    />}

    {cl === "communication_ehealth" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsCommunicationSmall
      source="ehealth"
      object={object}
      setPremiumEhealthOpen={setPremiumEhealthOpen}
      setEhealthInitOpen={setEhealthInitOpen}
    />}

    {cl === "communication_zorg" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsCommunicationSmall
      source="zorg"
      object={object}
      setPremiumZorgmailOpen={setPremiumZorgmailOpen}
      setZorgmailInitOpen={setZorgmailInitOpen}
    />}

    {cl === "basic_intake" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicIntake
      object={object}
    />}

    {cl === "basic_treatment" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicTreatment
      object={object}
    />}

    {cl === "basic_measure_uploads" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicMeasureUploads
      object={object}
    />}

    {cl === "basic_advice_uploads" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicAdviceUploads
      object={object}
    />}

    {cl === "basic_advice" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicAdvice
      object={object}
    />}

    {cl === "basic_sleep" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsBasicSleep
      object={object}
    />}

    {cl === "timeline" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsTimeline
      object={object}
    />}

    {/* Module gate (nutri_workshop) lives inside the widget: render null when off. */}
    {cl === "workshops" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsWorkshops
      object={object}
    />}

    {cl === "calculation" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsCalculation
      object={object}
    />}

    {cl === "status" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsStatus
      object={object}
    />}

    {cl === "internal_comment" && object?.type === "User::User" && !login?.is_secretary && <CoachUserWidgetsInternalComment
      object={object}
      objectRefetch={objectRefetch}
    />}

    {cl === "goto_links" && <CoachUserWidgetsGotoLinks
      object={object}
    />}

    {cl === "actions" && object?.type === "User::User" && <CoachUserWidgetsActions
      object={object}
      mutationCustomAction={mutationCustomAction}
      passResetLink={passResetLink}
      passResetEmail={passResetEmail}
      setNewEpisodeWarningOpen={setNewEpisodeWarningOpen}
    />}

    {cl === "account_mgmnt" && object?.type === "User::User" && !!object.consent_status?.enabled && object.email.indexOf("accountclosed") < 0 && <CoachUserWidgetsAccountManagement
      object={object}
      mutationCustomAction={mutationCustomAction}
      passResetLink={passResetLink}
      passResetEmail={passResetEmail}
    />}
  </>;
}
